import { Helmet } from 'react-helmet-async';
import { Grid } from '@mui/material';
import useResponsive from '../hooks/useResponsive';
import { LoginForm } from '../sections/auth/login';
import { Typography } from '@mui/material';
import './component/style.css';
import React from 'react';
import { LoginButton, LogoutButton } from './component/buttonkeycloak';
import keycloak from '../keycloak';
import { getToken, getFullname, getRole } from 'src/utils/common';
import { useKeycloak } from '@react-keycloak/web';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { init } from 'i18next';
import { removeUserSession } from 'src/utils/common';

export default function LoginPage() {
  const navigate = useNavigate();
  const mdUp = useResponsive('up', 'md');
  const { keycloak, initialized } = useKeycloak();
  const location = useLocation();
  const token = getToken();
  const role = getRole();
  useEffect(() => {
    if (role === 'undefined' && initialized && keycloak.authenticated) {
      sessionStorage.clear();
      sessionStorage.setItem('token', 'gada');
      sessionStorage.setItem('role', 'norole');
    } else if (['maker', 'checker', 'data_owner', 'super_admin', 'data_viewer'].includes(role)) {
      // if(sessionStorage.getItem('token') === 'gada') {

      // }
      if (sessionStorage.getItem('token') == null) {
        removeUserSession();
        navigate('/login', { replace: true });
      } else {
        navigate('/welcome', { replace: true });
      }
      // Redirect to the appropriate route
    }
    if (keycloak.authenticated && location.pathname === '/login' && initialized) {
      if (sessionStorage.getItem('token') == null) {
        removeUserSession();
        navigate('/login', { replace: true });
      } else {
        navigate('/welcome', { replace: true });
      }
    }
  }, [role, navigate]);

  if (!initialized) {
    return null; // Hide the login screen (could be replaced with a spinner or loading)
  }
  return (
    <>
      <Helmet>
        <title> Login | SmartShield </title>
      </Helmet>
      <Grid
        xs={12}
        item
        md={6}
        style={{
          // backgroundColor: '',
          backgroundImage: 'url(/assets/Signup.png)',
          backgroundSize: 'cover', // Adjust this as needed
          backgroundPosition: 'absolute', // Adjust this as needed
          height: '100vh',
          zIndex: '1',
        }}
      >
        {''}
        {!token ? (
          <div className="relative z-100 container mx-auto px-4 h-full">
            <div className="relative flex content-center items-center justify-center h-full">
              <img src="/assets/smartshild.png" alt="smartshield Logo" className="w-100" />

              <div className="text-center mb-3">
                <Typography variant="h2" align="center" style={{ color: '#00000' }}>
                  Welcome to <span style={{ color: '#1dbcee' }}>SMART</span>
                  <span style={{ color: '#21386d' }}>SHIELD</span>
                </Typography>
                <Typography variant="h3" align="center" style={{ color: '#00000', paddingBottom: '30px' }}>
                  A Blockchain-based Intelligent Data Integrity System to Protect the Integrity of Your Mission Critical
                  Data.
                </Typography>
                <LoginButton />
                <div style={{ paddingTop: '30px' }}> {token ? <LogoutButton /> : ''}</div>

                <div className="w-full">
                  <Typography variant="h6" align="center" style={{ color: '#21386d', paddingTop: '30px' }}>
                    {' '}
                    &copy; 2024 ChainSmart - All Rights Reserved
                  </Typography>
                </div>
              </div>
            </div>
            <div style={{ width: '100%' }} className="flex-auto px-4 lg:px-10 py-10 pt-0"></div>
          </div>
        ) : (token && role === 'undefined') || role === 'norole' || role === 'null' ? (
          <div className="relative z-100 container mx-auto px-4 h-full">
            <div className="relative flex content-center items-center justify-center h-full">
              <img src="/assets/smartshild.png" alt="smartshield Logo" className="w-100" />

              <div className="text-center mb-3">
                <Typography variant="h2" align="center" style={{ color: '#00000' }}>
                  Welcome to <span style={{ color: '#1dbcee' }}>SMART</span>
                  <span style={{ color: '#21386d' }}>SHIELD</span>
                </Typography>
                <Typography variant="h3" align="center" style={{ color: '#00000', paddingBottom: '30px' }}>
                  Please contact your administrator to get access to the system.
                </Typography>
                <div> {token ? <LogoutButton /> : ''}</div>

                <div className="w-full">
                  <Typography variant="h6" align="center" style={{ color: '#21386d', paddingTop: '30px' }}>
                    {' '}
                    &copy; 2024 ChainSmart - All Rights Reserved
                  </Typography>
                </div>
              </div>
            </div>
            <div style={{ width: '100%' }} className="flex-auto px-4 lg:px-10 py-10 pt-0"></div>
          </div>
        ) : (
          <div className="relative z-100 container mx-auto px-4 h-full">
            <div className="relative flex content-center items-center justify-center h-full">
              <img src="/assets/smartshild.png" alt="smartshield Logo" className="w-100" />

              <div className="text-center mb-3">
                <Typography variant="h2" align="center" style={{ color: '#00000' }}>
                  Welcome to <span style={{ color: '#1dbcee' }}>SMART</span>
                  <span style={{ color: '#21386d' }}>SHIELD</span>
                </Typography>
                <Typography variant="h3" align="center" style={{ color: '#00000', paddingBottom: '30px' }}>
                  Idle detected, Please login again
                </Typography>
                <div style={{ paddingTop: '30px' }}> {token ? <LogoutButton /> : ''}</div>

                <div className="w-full">
                  <Typography variant="h6" align="center" style={{ color: '#21386d', paddingTop: '30px' }}>
                    {' '}
                    &copy; 2024 ChainSmart - All Rights Reserved
                  </Typography>
                </div>
              </div>
            </div>
            <div style={{ width: '100%' }} className="flex-auto px-4 lg:px-10 py-10 pt-0"></div>
          </div>
        )}
      </Grid>
    </>
  );
}
